export default "__VITE_ASSET__11551401__"